const RTLLANGUAGES = ['iw', 'ar', 'ur', 'fa', 'ps']

export const isRTLLanguage = code => {
  try {
    const pair = code.split('-')
    return RTLLANGUAGES.indexOf(pair[0]) > -1
  } catch (e) {
    return false
  }
}
